const slimline = {
  id: 1,
  type: "stilesAndRails",
  label: "Slimline | Ultra-Modern",
  stileCategory: "Slimline",
};

const euro = {
  id: 2,
  type: "stilesAndRails",
  label: "Euro | Contemporary",
  stileCategory: "Euro",
}

const traditional = {
  id: 3,
  type: "stilesAndRails",
  label: "Traditional | Classic",
  stileCategory: "Traditional",
}

const pico = {
  id: 4,
  type: "stilesAndRails",
  label: "Pico | Minimalist",
  stileCategory: "Pico"
};

const cladRails = [
  slimline,
  euro,
  traditional,
];

const bifoldCladRails = [
  pico,
  slimline,
  euro,
  traditional
];

const swingCladRails = [
  pico,
  slimline,
  euro,
  traditional
];

const windowRails = [
  pico,
  slimline,
  euro,
];

const slimlineOptions = [
  {
    id: 1,
    type: "stilesAndRails",
    label: "Slimline",
  },
  {
    id: 2,
    type: "stilesAndRails",
    label: "Slimline Traditional",
  },
];

const woodRails = [
  euro,
  traditional,
];

const cladTradBtm = [
  {
    id: 1,
    type: "stilesAndRails",
    label: 'Bottom rail 7"',
  },
  {
    id: 2,
    type: "stilesAndRails",
    label: 'Bottom rail 4-3/4"',
  },
];

const lockrailEven = {
  id: 1,
  type: "lockRail",
  label: '2-1/2" Stiles and Rails',
};


const aluminumRails = [
  {
    id: 1,
    type: "stilesAndRails",
    label: "Functional",
  },
  {
    id: 2,
    type: "stilesAndRails",
    label: "Classic",
  },
];

export {
  lockrailEven,
  cladTradBtm,
  woodRails,
  slimlineOptions,
  windowRails,
  cladRails,
  swingCladRails,
  bifoldCladRails,
  aluminumRails,
};
